import { Button, Stack, Typography } from "@mui/material";
import BmiCard from "./components/BmiCard";
import { useGetLatestWeightQuery } from "src/api/services/weightTrackerApi";
import GoalCard from "./components/GoalCard";
import HealthInformationCard from "./components/HealthInformationCard";
import { eatingHabits, pastExperience } from "./utils/healthInformation";
import { theme } from "src/assets/theme";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useCallback } from "react";

const ResultInformation = () => {
  const isMobile = useIsMobile();
  const { data } = useGetLatestWeightQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const page = "result-information";
  const { t } = useTranslation();
  const { submitAnswer } = useSubmitAnswers();

  const { header, caption, list } = pastExperience;
  const {
    header: habitsHeader,
    caption: habitsCaption,
    list: habitsList,
  } = eatingHabits;

  const handleNext = useCallback(
    () => submitAnswer(["Ignore"]),
    [submitAnswer]
  );

  if (data == null) return null;

  return (
    <Stack gap={3}>
      <Typography variant="h3">{t(`${page}.title1`)} </Typography>
      <BmiCard patientWeight={data} page={page} onNext={handleNext} />
      <Button
        onClick={handleNext}
        sx={{ borderRadius: "30px", height: "65px", padding: 2 }}
      >
        <Typography
          variant={isMobile ? "body1" : "h6"}
          color="#ffffff"
          fontWeight={600}
        >
          {t(`${page}.continue`)}
        </Typography>
      </Button>
      <GoalCard patientWeight={data} page={page} onNext={handleNext} />
      <Button
        sx={{ borderRadius: "30px", height: "65px", padding: 2 }}
        onClick={handleNext}
      >
        <Typography
          variant={isMobile ? "body1" : "h6"}
          color="#ffffff"
          fontWeight={600}
        >
          {t(
            `${page}.continue`,
            "Continue to receive treatment straight to your door"
          )}
        </Typography>
      </Button>
      <Typography variant="h4" fontWeight={600}>
        {t(`${page}.caption1`)}{" "}
        <span style={{ color: theme.palette.secondary.main }}>
          {t(`${page}.caption2`)}
        </span>{" "}
        {t(`${page}.caption3`)}
      </Typography>
      <HealthInformationCard
        header={header}
        caption={caption}
        list={list}
        onNext={handleNext}
      />
      <HealthInformationCard
        header={habitsHeader}
        caption={habitsCaption}
        list={habitsList}
        onNext={handleNext}
      />
      <Button onClick={handleNext}>{t("button.next", "Next")}</Button>
    </Stack>
  );
};

export default ResultInformation;
